import { get } from 'axios';

export const getAccommodations = async bookingRef => {
  const { data } = await get(`/api/package/${bookingRef}/accommodation`);

  return {
    bookingRef,
    accommodations: data.accommodations,
  };
};

export const getAccommodationsAvailability = async bookingRef => {
  const { data } = await get(
    `/api/package/${bookingRef}/accommodationavailability`,
  );

  return {
    bookingRef,
    rooms: data.rooms,
  };
};
